import jwt from 'jsonwebtoken';
import User from '../models/User';
import { NullPointerException, ValidationException } from './Exceptions';

const getClaimsFromToken = token => {
    if (token) {
        const decodedToken = jwt.decode(token);
        return decodedToken['http://lwt'];
    }
    return null;
};

const storeToken = token => {
    sessionStorage.setItem('token', token);
};

const clearToken = () => {
    sessionStorage.removeItem('token');
};

const getToken = () => {
    return sessionStorage.getItem('token');
};

const isAuthenticated = () => {
    return !isTokenExpired(getToken());
};

const getLwtUser = (role) => {
    const token = getToken();
    if (!token)
        throw new NullPointerException('Token was null');
    const user = getUserFromToken(role);
    if (user && user.lwt && user.lwt.cid)
        return user;
    else
        throw new ValidationException('User object did not have clientId property');
};

const isTokenExpired = token => {
    if (!token) return true;
    const decodedToken = jwt.decode(token);
    return decodedToken.exp * 1000 <= new Date().getTime();
};

const getUserFromToken = (_role) => {
    const decodedToken = jwt.decode(getToken());
    const lwtClaims = decodedToken['http://lwt'];
    let role = _role && _role.roleName;
    let appIds = _role && _role.appIds;
    return new User(
        decodedToken.given_name,
        decodedToken.family_name,
        decodedToken.nickname,
        role,
        lwtClaims.cid,
        appIds,
        lwtClaims,
        decodedToken.email
    );
};

export {
    isAuthenticated,
    getClaimsFromToken,
    getLwtUser,
    getToken,
    storeToken,
    getUserFromToken,
    clearToken
};
